import { Alert } from 'ui';

const Processing = () => (
  <Alert description="We’re processing your video files. This may take a short while." title="Processing videos" />
);

export default Processing;
